export const iconFontAwesomeGamingRing = (
	<i className="fa-solid fa-ring"></i>
);
